import { escape } from 'lodash';
import {
  ADD_TEXT,
  SAVE_TEXT_PROPERTIES,
  LOAD_TEXTS_BY_BOOK_ID,
  TOGGLE_TEXT_ACTIVE,
  CHANGE_TEXT_PROPERTY,
  DELETE_TEXT,
} from '../../action-types/entities/texts';

import { generateId } from './../../helpers';

export const STATE_KEY = 'texts';

export const texts = (state = {}, action) => {
  switch (action.type) {
    case ADD_TEXT: {
      const { textProperties } = action;
      const randomId = generateId(Object.keys(state), 10000);

      return {
        ...state,
        [randomId]: textProperties,
      };
    }

    case SAVE_TEXT_PROPERTIES: {
      const {
        id: actionId,
        properties,
      } = action;

      const {
        images,
        text,
      } = properties;


      const textsByID = {};
      const texts = state;

      for (const id in texts) {
        if (id in texts) {
          const page = Object.assign({}, texts[id]);
          if (page.id === parseInt(actionId, 10)) {
            page.text = escape(text);
            page.images = images;
          }
          textsByID[id] = page;
        }
      }

      return Object.assign({}, state, textsByID);
    }

    case TOGGLE_TEXT_ACTIVE: {
      const { textId } = action;
      const textsByID = {};
      const texts = state;

      for (const id in texts) {
        if (id in texts) {
          const page = texts[id];
          page.isActive = textId === parseInt(id, 10);
          textsByID[id] = page;
        }
      }

      return Object.assign({}, state, textsByID);
    }

    case CHANGE_TEXT_PROPERTY: {
      const {
        textId,
        property,
        value,
      } = action;

      const textProperties = {};
      const textState = state;

      for (const page in textState) {
        if (page in textState) {
          const TextProp = Object.assign({}, state[page]);
          textProperties[page] = TextProp;
          if (textProperties[page].id === textId && property in textProperties[page]) {
            textProperties[page][property] = value;
          }
        }
      }

      return Object.assign({}, state, textProperties);
    }

    case DELETE_TEXT: {
      const { textId } = action;
      const removedTexts = {};
      const textsState = state;

      for (const text in textsState) {
        if (text in textsState) {
          const TextProp = Object.assign({}, textsState[text]);
          if (TextProp.id !== textId) {
            removedTexts[text] = TextProp;
          }
        }
      }

      return Object.assign({}, removedTexts);
    }

    case LOAD_TEXTS_BY_BOOK_ID: {
      const { texts } = action;
      return Object.assign({}, state, texts);
    }

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/reducers/entities/texts.js